var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"id":"FAQ-Page"}},[_c('heroSection',{attrs:{"header":_vm.header}}),_c('main',{staticClass:"container mt-5 pt-96 pb-96"},[_c('div',{staticClass:"col-md-12 mx-auto"},[_vm._l((_vm.faqs),function(faq,i){return [_c('faq-component',{key:i,attrs:{"question":faq.q,"answer":faq.a,"iterator":i}})]})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }